import { TpvTransaction } from '@app/domain/models/tpv/transaction.model';
import { TransactionDto } from '@app/data/dtos/tpv/transaction.dto';

/** DTO de transacción -> entidad de dominio. */
export function mapTransaction(dto: TransactionDto): TpvTransaction {
  return {
    idTransaction: dto.id_transaction ?? '',
    status: dto.status ?? '',
    createdAt: dto.created_at ?? '',
    idTerminal: dto.id_terminal ?? '',
    externalIdMerchant: dto.id_merchant ?? '',
    merchantName: dto.merchant_name ?? '',
    processor: dto.processor ?? '',
    type: dto.type ?? '',
    paymentGateway: dto.payment_gateway ?? '',
    paymentMethod: dto.payment_method ?? '',
    email: dto.email ?? '',
    grossAmount: Number(dto.gross_amount ?? 0),
    tip: Number(dto.tip ?? 0),
    commissionFee: Number(dto.commission_fee ?? 0),
    commissionAmount: Number(dto.commission_amount ?? 0),
    iva: Number(dto.iva ?? 0),
    ivaAmount: Number(dto.iva_amount ?? 0),
    quotas: Number(dto.quotas ?? 0),
    receivedMerchantAmount: Number(dto.received_merchant_amount ?? 0),
    orgIdCompany: dto.org_id_company,
    unitName: dto.unit_name,
    companyName: dto.company_name,
    affiliation: dto.affiliation,
    cardBrand: dto.card_brand,
    cardProduct: dto.card_product,
    cardBin: dto.card_bin,
    cardLast4: dto.card_last4,
    entryMode: dto.entry_mode,
    operationType: dto.operation_type,
    folio: dto.folio,
    reference: dto.reference,
    // El backend expone el nº de autorización como `auth_code` (no authorization_code).
    authorizationCode: dto.auth_code,
    responseCode: dto.response_code,
  };
}
